import { render } from "./template.1354.vue?vue&type=template&id=4af33299"
import script from "./template.1354.vue?vue&type=script&lang=js"
export * from "./template.1354.vue?vue&type=script&lang=js"

import "./template.1354.vue?vue&type=style&index=0&id=4af33299&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__